import { defineMessages } from '../define';

export default defineMessages({});
